import React from "react";

import { CONTACT_DETAILS } from "../../data/content";
import { BrandIcon } from "./Icons";

//WhatsApp / Facebook / Instagram, as on Wix (the Wix WhatsApp icon dialled a broken number - it now opens a WhatsApp chat)
const LINKS = [
  { name: "whatsapp", label: "Chat to Estia on WhatsApp", href: CONTACT_DETAILS.WHATSAPP_LINK },
  { name: "facebook", label: "Estia on Facebook", href: CONTACT_DETAILS.FACEBOOK_LINK },
  { name: "instagram", label: "Estia on Instagram", href: CONTACT_DETAILS.INSTAGRAM_LINK },
];

const SocialIcons = ({ className = "" }) => (
  <ul className={`social-icons ${className}`}>
    {LINKS.map((link) => (
      <li key={link.name}>
        <a
          href={link.href}
          target={"_blank"}
          rel={"noopener noreferrer"}
          aria-label={link.label}
          className={"social-icon"}
        >
          <BrandIcon name={link.name} />
        </a>
      </li>
    ))}
  </ul>
);

export default SocialIcons;
